<script>
  import { TextInput, Button } from "paxray-components-svelte";
  import SubActivityDataTable from "./SubActivityDataTable.svelte";
  import { PLUS_ICON } from "@utils/icons.js";

  export let rowToEdit = {
    id: "",
    activity: "",
    activityExpense: "",
    activityStart: "",
    activityEnd: "",
    activityDate: "",
    clientProcessId: null,
  };
  export let subActivitiesByRow = [];
  export let headers;
  export let rowsExpandable = [];
  export let deletedSubActivityRows = [];
  export let selectedActivity;
  export let handleEdit = () => {};
  export let handleDateChange = () => {};
  export let handleUpdateTime = () => {};
  export let deletedActivityRows = [];
  export let handleAdd = () => {};

  $: {
    if (deletedActivityRows.length > 0) {
      rowsExpandable = [...rowsExpandable];
    }
  }
  function handleNewSubActivity() {
    rowsExpandable = [
      ...rowsExpandable,
      {
        id: rowsExpandable.length + 1,
        subActivityName: "",
        subActivityExpense: "",
        subActivityStart: "",
        subActivityEnd: "",
        subActivityDate: "",
        activityId: selectedActivity,
      },
    ];
  }

  function handleDelete(id) {
    console.log("Delete subActivity", id);
    if (deletedSubActivityRows.includes(id)) {
      deletedSubActivityRows = deletedSubActivityRows.filter(
        (row) => row !== id,
      );
    } else {
      deletedSubActivityRows = [...deletedSubActivityRows, id];
    }
    rowsExpandable = [...rowsExpandable];
  }
</script>

<div>
  <TextInput
    label="Name ändern"
    id="kommentar"
    placeholder={rowToEdit.activity}
    bind:value={rowToEdit.activity}
  />
</div>

<div style="margin-top: 2rem;">
  <span class="table-label">Subaktivität definieren</span>
  <SubActivityDataTable
    {subActivitiesByRow}
    {headers}
    {deletedSubActivityRows}
    {handleEdit}
    {handleDelete}
    {handleDateChange}
    {handleUpdateTime}
    {deletedActivityRows}
    {handleAdd}
  />
</div>
<div style="margin-top: 1rem;">
  <Button
    size="small"
    icon={PLUS_ICON}
    kind="secondary"
    on:click={handleNewSubActivity}
  />
</div>

<style>
  .table-label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-weight: 700;
    color: #1f2937;
  }
</style>
